import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiHtml5,
  DiCss3,
} from "react-icons/di";

function LanguageStack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
       <Col xs={4} md={2} className="tech-icons">
        <DiHtml5/>
        <h4>HTML</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
        <h4>CSS</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <h4>JavaScript</h4>
      </Col>
    </Row>
  );
}

export default LanguageStack;
